import { store } from '../store'
import { ACCOUNT_SCREENS, SIGN_UP_SCREENS } from '../constants'

const setFrameVisible = iframe => {
  if (iframe.style.visibility !== 'visible') iframe.style.visibility = 'visible'
}

const setFrameInvisible = iframe => {
  if (iframe.style.visibility !== 'hidden') iframe.style.visibility = 'hidden'
}

const handleFreshchatVisibility = (
  location
) => {
  const freshChatIframe = document.getElementById('fc_frame')
  if (!freshChatIframe) return
  toggleFreshchatVisibility(freshChatIframe, location, store.getState().session?.decodedJwt) // `reducers/session.js`
}

export const toggleFreshchatVisibility = (
  freshChatIframe,
  location,
  decodedJwt
) => {
  // when decodedJwt is null(something's wrong), hide chat bubble
  if (!decodedJwt) {
    setFrameInvisible(freshChatIframe)
    return
  }
  /**
   * chat bubble is only displayed on below screens
   * - My Account
   * - Sign up
   * - Home (except kids profile)
   */
  if (
    location.pathname.startsWith(ACCOUNT_SCREENS.MY_ACCOUNT.path) ||
    location.pathname.startsWith(SIGN_UP_SCREENS.SIGN_UP.path) ||
    (location.pathname === '/' && !decodedJwt.isKid)
  ) {
    setFrameVisible(freshChatIframe)
    return
  }

  setFrameInvisible(freshChatIframe)
}

const configFreshChat = history => {
  // handle refreshing the app (`history.listen` will not be triggered after refresh); timer2 is for when the chat bubble is loaded very slow that is not detected in timer1
  const timer1 = setTimeout(() => handleFreshchatVisibility(history.location), 2000)
  const timer2 = setTimeout(() => handleFreshchatVisibility(history.location), 5000)
  // handle normal navigation
  const unlistenFreshchat = history.listen(location => {
    handleFreshchatVisibility(location)
  })

  return () => {
    unlistenFreshchat()
    clearTimeout(timer1)
    clearTimeout(timer2)
  }
}

export default configFreshChat
